import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Pencil } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';

/**
 * Small floating pill that appears on pages whose content lives in a
 * dedicated backend editor (not in the generic page_content collection).
 * Clicking it takes the admin straight to the dedicated admin editor.
 * Appends ?from=<current path> so the editor can return the admin here.
 * Renders nothing for non-admins.
 */
export const AdminEditorLink = ({ to, label = 'Edit this page', bottomClass = 'bottom-52' }) => {
  const { isAdmin } = useAuth();
  const location = useLocation();
  const isAdminUser = typeof isAdmin === 'function' ? isAdmin() : false;
  if (!isAdminUser) return null;
  const from = encodeURIComponent(location.pathname + location.search);
  const toWithFrom = typeof to === 'string'
    ? `${to}${to.includes('?') ? '&' : '?'}from=${from}`
    : to;
  return (
    <Link
      to={toWithFrom}
      data-testid="admin-editor-link"
      className={`fixed left-4 ${bottomClass} z-[9999] inline-flex items-center gap-2 px-4 py-2 rounded-full bg-black/85 backdrop-blur-md border border-primary/50 shadow-2xl text-primary text-sm font-semibold hover:bg-primary/10 transition-colors`}
    >
      <Pencil className="w-4 h-4" />
      {label}
    </Link>
  );
};

export default AdminEditorLink;
